import { useEffect, useState } from 'react';
import { getKvantWb } from '../../../../utils';
import styles from './styles.module.scss';
import Column from '../../../../components/Basic/Blocks/Column';
import Input from '../../../../components/Basic/Inputs/Base';
import TextGrey from '../../../../components/Basic/WrapsStyle/TextGrey';

export default function WbInputName({ product, value = '', label = '', onChange = () => {}, ...props }) {
  const [name, setName] = useState('');

  const onChangeInput = (v) => {
    onChange(v);
    setName(v);
  };
  useEffect(() => {
    setName(value);
  }, [value]);

  const wb_kvant = getKvantWb(product.price, product.unitName);
  const wb_name = `${name}${wb_kvant}`;

  return (
    <Column {...props}>
      <Input
        value={name}
        onChange={(v) => onChangeInput(v)}
        label={label}
        styles={wb_name.length > 60 && styles.wb_name}
      />
      <TextGrey fontSize={8} style={{ marginTop: '12px' }}>
        {name.length}+{wb_kvant.length} = {name.length}
      </TextGrey>
    </Column>
  );
}
